import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'XInputNumber',
  props: {
  width: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const moveCursorToEnd = (event: any) => {
    const input = event.target;
    input.selectionStart = input.value.length;
    input.selectionEnd = input.value.length;
}



return (_ctx: any,_cache: any) => {
  const _component_InputNumber = _resolveComponent("InputNumber")!

  return (_openBlock(), _createBlock(_component_InputNumber, {
    inputStyle: 'font-weight: bold; font-size: 14px; text-align: right;'+__props.width,
    onClick: moveCursorToEnd
  }, null, 8, ["inputStyle"]))
}
}

})